import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RotateCcw, Home } from "lucide-react";

/**
 * Uygulama seviyesi hata sınırı. React render sırasında oluşan hataları yakalar
 * ve kullanıcıya Türkçe, tarz-uyumlu bir hata sayfası gösterir.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Sentry benzeri external hata takibi ileride eklenebilir
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  goHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen auth-bg grid place-items-center p-6" data-testid="error-boundary">
          <div className="max-w-lg text-center p-10 rounded-3xl bg-card border border-border ambient-shadow">
            <div className="w-16 h-16 mx-auto rounded-2xl bg-red-500/15 text-red-500 grid place-items-center mb-4">
              <AlertTriangle size={32} />
            </div>
            <h1 className="font-display text-2xl font-bold mb-2">Bir şeyler ters gitti</h1>
            <p className="text-sm text-muted-foreground mb-6">
              Bu bölümü yüklerken beklenmedik bir hata oluştu. Sayfa yenilenip tekrar denenebilir; sorun devam ederse yöneticiye bildir.
            </p>
            {this.state.error?.message && (
              <div className="text-[11px] font-mono bg-secondary p-3 rounded-xl text-left mb-6 overflow-x-auto" data-testid="error-detail">
                {String(this.state.error.message).slice(0, 300)}
              </div>
            )}
            <div className="flex gap-2 justify-center">
              <Button onClick={this.reset} className="rounded-full" data-testid="error-retry">
                <RotateCcw size={14} className="mr-1.5" /> Tekrar Dene
              </Button>
              <Button onClick={this.goHome} variant="outline" className="rounded-full" data-testid="error-home">
                <Home size={14} className="mr-1.5" /> Ana Sayfa
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
